import { AnalyticsMembershipEvent } from '@fruitful/types';

import { trackForMembership } from '../../logger/Logger';
import { usePreMoneyMapCompleteness } from '../../onboarding/hooks/usePreMoneyMapCompleteness';

interface FinancialProfileUpdates {
    employmentUpdated?: boolean;
    taxesUpdated?: boolean;
    insuranceUpdated?: boolean;
    kidsUpdated?: boolean;
    incomeUpdated?: boolean;
}

export const useTrackFinancialProfileCompletion = () => {
    const {
        hasViewedLinkMoreAccounts,
        isEmploymentStatusComplete,
        isTaxDataComplete,
        isInsuranceDataComplete,
        isKidsDataComplete,
        isFinancialProfileComplete,
        isIncomeComplete,
    } = usePreMoneyMapCompleteness();

    const trackFinancialProfileUpdate = (updates: FinancialProfileUpdates) => {
        const {
            employmentUpdated,
            taxesUpdated,
            insuranceUpdated,
            kidsUpdated,
            incomeUpdated,
        } = updates;

        const afterEmployment = employmentUpdated ?? isEmploymentStatusComplete;
        const afterTax = taxesUpdated ?? isTaxDataComplete;
        const afterInsurance = insuranceUpdated ?? isInsuranceDataComplete;
        const afterKids = kidsUpdated ?? isKidsDataComplete;
        const afterIncome = incomeUpdated ?? isIncomeComplete;
        const willBeComplete =
            afterEmployment &&
            afterTax &&
            afterInsurance &&
            afterKids &&
            afterIncome;

        if (!isFinancialProfileComplete && willBeComplete) {
            trackForMembership(
                AnalyticsMembershipEvent.FINANCIAL_PROFILE_COMPLETED,
            );

            if (hasViewedLinkMoreAccounts) {
                trackForMembership(
                    AnalyticsMembershipEvent.PRE_MONEY_MAP_ONBOARDING_COMPLETED,
                );
            }
        }
    };

    return { trackFinancialProfileUpdate };
};
